// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"408":"8c71c35e","938":"dde5143e"}[chunkId] + ".chunk.css";
};